var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:['sidebar-toggle-button', _vm.icon],attrs:{"circle":"","type":"text"},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }